export default function isString(input) {
    return typeof input === 'string' || input instanceof String;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-string.js
// module id = 801
// module chunks = 5